//@ts-nocheck
import React from 'react'

import { convertOnAccountContainers, convertInCashContainers } from './addContainers'
import { convertOnAccountEditContainers, convertInCashEditContainers } from './editContainers'
import ConvertOnAccountInCashModal from './ConvertOnAccountInCashModal'

export const DecoratedConvertOnAccountModal = convertOnAccountContainers(ConvertOnAccountInCashModal)
export const DecoratedConvertInCashModal = convertInCashContainers(ConvertOnAccountInCashModal)
const DecoratedConvertOnAccountEditModal = convertOnAccountEditContainers(ConvertOnAccountInCashModal)
const DecoratedConvertInCashEditModal = convertInCashEditContainers(ConvertOnAccountInCashModal)

export const ConvertOnAccountFormModal = ({ name }) => <DecoratedConvertOnAccountModal name={name} OperTypeID={6} />

export const ConvertOnCashboxFormModal = ({ name }) => <DecoratedConvertInCashModal name={name} OperTypeID={7} inCash />

export const OrderConvertOnAccountEdit = ({ onOrderAddEdit, onAuthorize, name }) => (
  <DecoratedConvertOnAccountEditModal
    editting
    OperTypeID={6}
    onAuthorize={onAuthorize}
    onOrderAddEdit={onOrderAddEdit}
    name={name}
  />
)

export const OrderConvertOnAccountCopy = ({ onOrderAddEdit, name }) => (
  <DecoratedConvertOnAccountEditModal copy OperTypeID={6} onOrderAddEdit={onOrderAddEdit} name={name} />
)

export const OrderConvertInCashEdit = ({ onOrderAddEdit, onAuthorize, name }) => (
  <DecoratedConvertInCashEditModal
    inCash
    editting
    OperTypeID={7}
    onAuthorize={onAuthorize}
    onOrderAddEdit={onOrderAddEdit}
    name={name}
  />
)

export const OrderConvertInCashCopy = ({ onOrderAddEdit, name }) => (
  <DecoratedConvertInCashEditModal inCash copy OperTypeID={7} onOrderAddEdit={onOrderAddEdit} name={name} />
)
